// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMmF","input":"styles_input__22li3"};